<script>
import Modal from '@/components/atoms/Modal'
import ButtonLoader from '@/components/atoms/ButtonLoader'
export default {
    name: 'ModalLogout',
    components: { ButtonLoader, Modal },
    props: {
        title: String,
        text: String,
    },
    data() {
        return {
            loading: false,
        }
    },
    methods: {
        logout() {
            return new Promise((resolve) => {
                this.loading = true
                setTimeout(async () => {
                    await this.$user.logout({
                        text: this.$t('base.logout_success'),
                        title: this.$t('base.logout'),
                    })

                    if (this.$impersonate.state.isActive) {
                        this.$impersonate.logout()
                    }

                    this.$refs.logout.closeModal()
                    this.loading = false
                    resolve()
                }, 1500)
            })
        },
        open() {
            this.$refs.logout.openModal()
        },
        cancel() {
            this.$emit('cancel')
            this.$refs.logout.closeModal()
        },
    },
}
</script>

<template lang="pug">
modal(ref="logout" :closable="false")
    template(v-slot:header)
        .modal-header-text {{ title || $t('base.logout_sure') }}
    template(v-slot:body)
        p(v-html="text || $t('base.logout_desc')")
    template(v-slot:footer)
        button.btn.btn-secondary(@click="cancel")  {{$t('base.cancel')}}
        button-loader.btn.btn-primary(@click="logout" :loading="loading" inline) {{$t('base.logout')}}
</template>
